import httpClient from '@api/httpClient'
import type {
  VehicleProfileFilters,
  VehicleProfile,
} from '@models/vehicleProfile'
import type { PaginatedResponse } from '@models/pagination'
import { vehicleProfilesUrls } from './constants'

const getVehicleProfiles = async (filters: VehicleProfileFilters) => {
  const { companyId, ...params } = filters
  const { data } = await httpClient.get<PaginatedResponse<VehicleProfile>>(
    vehicleProfilesUrls.root(companyId),
    { params: { ...params, companyId } },
  )
  return data
}

export interface CreateVehicleProfileRequestData {
  companyId: number
  vehicleProfileExternalId: string
  name: string
}

const createVehicleProfile = async ({
  companyId,
  ...props
}: CreateVehicleProfileRequestData) => {
  const { data } = await httpClient.post<VehicleProfile>(
    vehicleProfilesUrls.root(companyId),
    props,
  )
  return data
}

export interface UpdateVehicleProfileRequestData {
  companyId: number
  id: number
  name: string
}

const updateVehicleProfile = async ({
  companyId,
  id,
  ...props
}: UpdateVehicleProfileRequestData) => {
  const { data } = await httpClient.patch<VehicleProfile>(
    vehicleProfilesUrls.vehicleProfile(companyId, id),
    props,
  )
  return data
}

export interface DeleteVehicleProfileRequestData {
  companyId: number
  id: number
}

const deleteVehicleProfile = async ({
  companyId,
  id,
}: DeleteVehicleProfileRequestData) => {
  const { data } = await httpClient.delete(
    vehicleProfilesUrls.vehicleProfile(companyId, id),
  )
  return data
}

export default {
  getVehicleProfiles,
  createVehicleProfile,
  updateVehicleProfile,
  deleteVehicleProfile,
}
